import React from 'react';
import { SiteHeader } from '../components/sales/SiteHeader';
import { HeroSection } from '../components/sales/HeroSection';
import { IdentificationSection } from '../components/sales/IdentificationSection';
import { BookSection } from '../components/sales/BookSection';
import { ResetSection } from '../components/sales/ResetSection';
import { StepsSection } from '../components/sales/StepsSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FaqSection } from '../components/sales/FaqSection';
import { SiteFooter } from '../components/sales/SiteFooter';
import { MobileStickyCta } from '../components/sales/MobileStickyCta';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-ivory font-sans text-carbon" data-id="element-212" data-mp="1twgftsfrjbzb">
      <SiteHeader data-id="element-213" data-mp="1ttkgbzo9of8r" />
      <main data-id="element-214" data-mp="3qoglsydl4mcf">
        <HeroSection data-id="element-215" data-mp="3qoypuh6ho4uw" />
        <IdentificationSection data-id="element-216" data-mp="3qpi7dws88r8e" />
        <BookSection data-id="element-217" data-mp="3qq9qw98juyib" />
        <ResetSection data-id="element-218" data-mp="3vn084zw3c05b" />
        <StepsSection data-id="element-219" data-mp="3vmi6fnqnstq0" />
        <FaqSection data-id="element-220" data-mp="3vnti09qcj5ro" />
        <OfferSection data-id="element-221" data-mp="3vpe3zaylhgdx" />
      </main>
      <SiteFooter data-id="element-222" data-mp="3ak8diam2xnpa" />
      <MobileStickyCta data-id="element-223" data-mp="3akrunp3wo829" />
    </div>;
}